import { createGlobalStyle } from 'styled-components'
const GlobalStyles = createGlobalStyle`
    body {
        margin: 0;
        padding: 0;
    }
    @font-face {
        font-family: 'Interface';
        font-style: normal;
        font-weight: normal;
        src: url('https://s3.amazonaws.com/giphy-web-fonts/InterFace_W_Rg.woff2') format('woff2'),
            url('https://s3.amazonaws.com/giphy-web-fonts/InterFace_W_Rg.woff') format('woff');
    }
    @font-face {
        font-family: 'Interface';
        font-style: normal;
        font-weight: bold;
        src: url('https://s3.amazonaws.com/giphy-web-fonts/InterFace_W_Bd.woff2') format('woff2'),
            url('https://s3.amazonaws.com/giphy-web-fonts/InterFace_W_Bd.woff') format('woff');
    }
    @font-face {
        font-family: 'Nexa Black';
        font-style: normal;
        font-weight: normal;
        src: url('https://s3.amazonaws.com/giphy-web-fonts/nexa_black-webfont.woff2') format('woff2'),
            url('https://s3.amazonaws.com/giphy-web-fonts/nexa_black-webfont.woff') format('woff');
    }
`

export default GlobalStyles
